export const COMPACT_LAYOUT_MAX_VIEWPORT_WIDTH_PX = 900

export const compactLayoutMediaQuery = `@media (max-width:${COMPACT_LAYOUT_MAX_VIEWPORT_WIDTH_PX}px)`
